export default __webpack_public_path__ + "static/char-14-dcbd2ba3d6c8fff9929238c630d17edd.gif";